type DocumentCountPillProps = {
  count: number
}

export const DocumentCountPill = ({ count }: DocumentCountPillProps) => {
  return (
    <span className="inline-flex h-5 items-center justify-center rounded-full bg-muted px-1.5 text-xs text-muted-foreground">
      {count}
    </span>
  )
}
